import { createContext } from "react";
import { DevicesCollection } from "./useDevicesCollectionInstance";
import { EventsCollection } from "./useEventsCollectionInstance";
import { HiveAssignmentsCollection } from "./useHiveAssignmentsCollectionInstance";
import { HivesCollection } from "./useHivesCollectionInstance";
import { LoadsCollection } from "./useLoadsCollectionInstance";
import { ScalesCollection } from "./useScalesCollectionInstance";

export interface CollectionsContextProps {
  devices: DevicesCollection;
  events: EventsCollection;
  hiveAssignments: HiveAssignmentsCollection;
  hives: HivesCollection;
  loads: LoadsCollection;
  scales: ScalesCollection;
}

export const CollectionsContext = createContext<
  CollectionsContextProps | undefined
>(undefined);
